import { PREVIEW_HOSTNAME_PREFIX } from '@layers/web/constants/preview.ts'

const isPreviewHostname = (hostname?: string | null): boolean => !!hostname && hostname.toLowerCase().startsWith(PREVIEW_HOSTNAME_PREFIX)

export {
  isPreviewHostname,
}
